// extracted by mini-css-extract-plugin
export default {"reportDownload":"ReportDownload_reportDownload__rFmJX","reportLabel":"ReportDownload_reportLabel__sgTxY","reportLink":"ReportDownload_reportLink__LKJ6s"};